import React from "react";
import { createContext, useEffect, useState } from "react"
import { createSession, setAuthToken, clearAuthData } from "../service/api";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkToken = () => {
      const userToken = localStorage.getItem("user_token");

      if (userToken) {
        try {
          const parsedUser = JSON.parse(userToken);
          
          // Verificar se o token existe e é válido
          if (parsedUser && parsedUser.token) {
            setUser(parsedUser);
            setAuthToken(parsedUser.token);
          } else {
            localStorage.removeItem("user_token");
            setUser(null);
          }
        } catch (error) {
          localStorage.removeItem("user_token");
          setUser(null);
        }
      } else {
        setUser(null);
      }

      setLoading(false);
    };

    // Verifica token inicial
    checkToken();

    // Detecta mudanças no localStorage (quando token é deletado manualmente em outra aba)
    const handleStorageChange = (e) => {
      if (e.key === 'user_token') {
        checkToken();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  const signin = async (data) => {
    try {
      const response = await createSession(data);
      const user = response.data;

      if (!user || !user.token) {
        throw new Error("Dados de autenticação inválidos");
      }

      localStorage.setItem("user_token", JSON.stringify(user));
      setAuthToken(user.token);
      setUser(user);

      return response;
    } catch (error) {
      console.error("Erro no login:", error);
      throw error;
    }
  };


  // const signup = (login, password) => {
  //     const usersStorage = JSON.parse(localStorage.getItem("users_bd"));

  //     const hasUser = usersStorage?.filter((user) => user.login === login);

  //     if (hasUser?.length) {
  //       return "Já tem uma conta com esse E-mail";
  //     }

  //     let newUser;

  //     if (usersStorage) {
  //       newUser = [...usersStorage, { login, password }];
  //     } else {
  //       newUser = [{ login, password }];
  //     }

  //     localStorage.setItem("users_bd", JSON.stringify(newUser));

  //     return;
  //   };

  const signout = () => {
    clearAuthData();
    setUser(null);
    
    // Redirecionar para login após logout
    // Usando window.location.replace evita adicionar entrada no histórico
    if (typeof window !== 'undefined') {
      window.location.replace('/login');
    }
  };

  const signed = !!user;

  return (
    <AuthContext.Provider
      value={{ user, signed, loading, signin, signout }}
    >
      {children}
    </AuthContext.Provider>
  );

};



